import {useSelectedLocale} from '../../i18n/selected-locale';
import {useLocalStorage} from '../../utils/hooks/local-storage';
import {Button} from '../../ui/buttons/button';
import {KeyboardArrowDownIcon} from '../../icons/material/KeyboardArrowDown';
import {
  Menu,
  MenuItem,
  MenuTrigger,
} from '../../ui/navigation/menu/menu-trigger';

const languages = [
  {code: 'es', flag: '🇪🇸', name: 'Spanish'},
  {code: 'en', flag: '🇬🇧', name: 'English'},
  {code: 'fr', flag: '🇫🇷', name: 'French'},
  {code: 'de', flag: '🇩🇪', name: 'German'},
  {code: 'it', flag: '🇮🇹', name: 'Italian'},
  {code: 'pt', flag: '🇵🇹', name: 'Portuguese'},
];

export function useCheckoutLanguage() {
  const {localeCode} = useSelectedLocale();
  const [savedLanguage, setLanguage] = useLocalStorage<string>(
    'talos.checkout.language',
  );
  const code = savedLanguage || localeCode.toLowerCase().split(/[-_]/)[0];
  const language = languages.find(item => item.code === code) || languages[1];
  return {
    language,
    setLanguage,
    termsUrl: `https://talosvue.com/legal/terms/?lang=${language.code}`,
    privacyUrl: `https://talosvue.com/legal/privacy/?lang=${language.code}`,
    supportUrl: '/contact',
    unsubscribeUrl: '/login',
    gdprUrl: `https://talosvue.com/legal/gdpr/?lang=${language.code}`,
    faqUrl: `https://talosvue.com/faq/?lang=${language.code}`,
  };
}

export function CheckoutLanguageSwitcher() {
  const {language, setLanguage} = useCheckoutLanguage();
  return (
    <MenuTrigger
      placement="top-start"
      floatingMinWidth="170px"
      selectionMode="single"
      selectedValue={language.code}
      showCheckmark={false}
      onSelectionChange={value => setLanguage(String(value))}
    >
      <Button
        className="checkout-language-trigger"
        aria-label="Language"
        endIcon={<KeyboardArrowDownIcon />}
      >
        <span aria-hidden="true">{language.flag}</span> Language
      </Button>
      <Menu>
        {languages.map(item => (
          <MenuItem
            key={item.code}
            value={item.code}
            className="checkout-language-option"
            startIcon={<span aria-hidden="true">{item.flag}</span>}
          >
            {item.name}
          </MenuItem>
        ))}
      </Menu>
    </MenuTrigger>
  );
}
